import Awesomplete from 'awesomplete';
import debounce from 'lodash/debounce';
import map from 'lodash/map';

const IGNORE_KEYS = [40, 38, 39, 37, 32];

const OrderLineForm = {
  /**
   * Create
   * @param {HTMLFormElement} node
   * @param {DOMStringMap} options
   * @return {void}
   */
  create(node, options) {
    this.node = node;
    this.options = options;

    // Find autocomplete field
    this.autocompleteField = this.node.querySelector('.js-line-autocomplete');

    // Initialize Awesomplete with an empty array
    this.createAwesomplete([]);

    // Debounce user input to prevent overflowing the API
    const debouncedKeyup = debounce(this.search.bind(this), 200);

    // Listen for changes on the autocomplete field
    this.autocompleteField.addEventListener('keyup', (e) => {
      if (IGNORE_KEYS.indexOf(e.keyCode) >= 0) {
        return true;
      }

      debouncedKeyup();

      return true;
    });
  },

  /**
   * Fetch products from the API
   * @return {void}
   */
  search() {
    const country = this.node.querySelector('[name="country_id"]');

    // Make the API call
    window.axios.post(window.API.ecommerce.productSearch, {
      search: this.autocompleteField.value,
      country_id: country.value,
    })
      .then((res) => {
        // Output data to Awesomplete
        this.awesomplete.list = res.data;
      })
      .catch((err) => {
        console.error(err); // eslint-disable-line no-console
      });
  },

  /**
   * Create Awesomplete instance
   * @param {array} list
   * @return {void}
   */
  createAwesomplete(list) {
    this.awesomplete = new Awesomplete(this.autocompleteField, {
      list,
      item: this.renderItem.bind(this),
      filter: this.filterItems,
      replace: this.replaceText.bind(this),
    });
  },

  /**
   * Filter items in Awesomplete. We always return true because the API filters for us
   * @return {boolean}
   */
  filterItems() {
    return true;
  },

  /**
   * Render list item with the value from the API
   * @param {Object} text
   * @return {HTMLLIElement}
   */
  renderItem(text) {
    const item = document.createElement('li');

    item.setAttribute('aria-selected', false);
    item.innerHTML = this.itemToText(text.value);

    return item;
  },

  /**
   * Replace the autocomplete input value when clicked or selected autocomplete item
   * @param {Object} text
   * @return {void}
   */
  replaceText(text) {
    this.autocompleteField.value = this.itemToText(text.value);

    this.outputToInputs(text.value);
  },

  /**
   * @param {object} item
   * @returns {string}
   */
  itemToText(item) {
    const sku = typeof item.sku !== 'undefined' && item.sku ? `(${item.sku})` : '';

    return `${item.title} - ${item.variant} ${sku}`;
  },

  /**
   * Output data to input fields in the order line form
   * @param {Object} obj
   * @return {void}
   */
  outputToInputs(obj) {
    map(obj, (item, key) => {
      const el = this.node.querySelector(`[data-autocomplete="${key}"]`);

      if (el) {
        el.value = item;
      }
    });
  },
};

export default OrderLineForm;
